<template>
    <cr-confirmation-dialog :title="title" :cancel="false" persistent :confirm-text="t('LEVEL_ENTRY_DIALOG_START')">
        <cr-row>    
            <cr-image :src="level.happyImageSrc" alt="" max-height="6rem" class="cr-mb4" data-testing="level-entry-dialog-image"/>
        </cr-row>
        <cr-row>
            <p>{{ level.description }}</p>
        </cr-row>
        <template #footerRight>
            <cr-button text :to="backRoute" data-testing="level-entry-dialog-back">
                {{ t('LEVEL_ENTRY_DIALOG_BACK') }}
            </cr-button>
        </template>
    </cr-confirmation-dialog>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Route from '../../routers/route';
import ILevel from '../../interfaces/iLevel';
import { computed } from 'vue';
const { t } = useI18n();

const props = defineProps<
{
    level: ILevel
}>();

const title = computed(() => t('LEVEL_ENTRY_TITLE', { prefix: props.level.namePrefix, suffix: props.level.nameSuffix }));
const backRoute = Route.LevelSelect;
</script>